<template>
  <div>
    <div
      ref="dataNum"
      class="base-swiper-item"
      v-if="$parent.showFlag"
      :style="{
    width:$parent.offsetWidth+'px',
    transform:`translateX(${ offsetWidth }px)`,
    'z-index':zIndex
  }"
    >
      <slot></slot>
    </div>
    <div
      v-else
      class="base-swiper-item"
      :style="{
    width:$parent.offsetWidth+'px',
    transform:`translateX(${ offsetWidth }px)`,
    transition:`transform ${delay}ms`,
    'z-index':zIndex
  }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseSwiperItem',
  components: {},
  data() {
    return {
      showFlag: true,
      offsetWidth: 0,
      zIndex: 1 //默认的都是1 如果是最后一个需要向前移动的时候 则是-1来实现隐藏
    };
  },
  computed: {
    delay() {
      return this.zIndex === -1 ? 0 : this.$parent.delay;
    }
  },
  mounted() {
    // console.log(this.showFlag);
  },
  methods: {
    setOffset(v, isCritical) {
      // console.log(isCritical);
      this.zIndex = isCritical ? -1 : 1;
      this.offsetWidth = v;
    }
  }
};
</script>
<style scoped>
.base-swiper-item {
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/components/base-swiper-item.vue